import { selectPartnersInitWaitingMessage } from './../_selectors/partner.selectors';
// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectPartnersInStore, selectPartnersPageLoading } from '../_selectors/partner.selectors';

export class PartnersDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectPartnersPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectPartnersInitWaitingMessage)
		);

		this.store.pipe(
			select(selectPartnersInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.resultCount);
			this.entitySubject.next(response.list);
		});
	}
}
